module.exports = __webpack_public_path__ + "img/address.0f967b75.svg";